import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';

const Container = styled(MuiBox, {
    shouldForwardProp: prop => !['isSorted', 'canSort', 'isCheckboxColumn', 'isFiltered', 'rtl', 'headerCellPadding'].includes(prop),
}) `
  ${({ theme, canSort, isSorted, disabled, isCheckboxColumn, isFiltered, rtl, headerCellPadding }) => `
      padding: ${isCheckboxColumn
    ? rtl
        ? '7px 12px 5px 10px'
        : '7px 10px 5px 10px'
    : typeof headerCellPadding === 'number'
        ? `${headerCellPadding}px`
        : headerCellPadding || theme.spacing(2, 2.5, 2, 2.5)};
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      user-select: none; 
      background-color: ${theme.palette.N95.main};

      .drag-icon {
        opacity: 0;
        cursor: grab;
        position: absolute;
        display: ${isCheckboxColumn ? 'none' : 'flex'};
        top: 50%;
        ${rtl ? 'right: 0' : 'left: 6'}px;
        transform: translate(-50%, -50%);
        align-items: center;
        align-content: center;
      }
      .filter-icon {
        opacity: ${isFiltered ? 0.5 : 0};
        > path {
          fill: ${isFiltered ? theme.palette.N20.main : theme.palette.primary.main};
        }
      }

      &:hover {
        background-color: ${!disabled && !isCheckboxColumn ? theme.palette.N70.main : 'inherit'};
        color: ${!disabled ? theme.palette.primary.main : 'inherit'};
        .sort-icon {
          fill: ${theme.palette.primary.main};
        }
        .drag-icon {
          opacity: 1;
        }
        .filter-icon {
          opacity: 1;
        }        
      }

    ${!!canSort &&
    `
        background-color: ${isSorted ? theme.palette.N70.main : ''};
        > div > *:last-child > svg:last-child {
          transition: opacity ${theme.transitions.duration.fast} linear;
          opacity: ${isSorted ? 1 : 0};                
        }  
        &:hover {
          > div > *:last-child > svg:last-child {
            color: ${theme.palette.N20.main};
            opacity: 1;
          } 
        }       
      `}
  `}
`;
const DragDummyPreview = styled('span') `
  opacity: 0.3;
`;
const CellDivider = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl }) => `
    opacity: 1;
    position: absolute;
    top: 0;
    ${rtl ? `left: 0` : 'right: -4px'};
    width: 1px;
    height: 100%;
    user-select: none;
    pointer-events: auto;
    &:after {
      content: '';
      position: absolute;
      z-index: 1;
      display: block;
     ${rtl ? `left: 0` : 'right: 0'};
      width: 1px;
      height: 100%;
      top: 0;
      background-color: transparent;
    }
  `}
`;
const ResizeHandler = styled(CellDivider, {
    shouldForwardProp: prop => !['rtl', 'isResizing'].includes(prop),
}) `
  ${({ theme, isResizing, rtl }) => `
    ${rtl ? `left: 0` : 'right: 0'}px;
    width: 8px;
    cursor: ew-resize;
    z-index: 2;
    &:after {
      background-color: ${isResizing ? theme.palette.primary.main : 'transparent'} !important;
    }
    &:hover {
      &:after {
        background-color: ${theme.palette.primary.main} !important;
      }
    }    
  `}
`;
const DropHandler = styled('div', {
    shouldForwardProp: prop => ['isDragActive', 'isAfter'].includes(prop),
}) `
  display: none;
  ${({ theme, isDragActive, isAfter }) => `
    ${isDragActive &&
    `
        position: absolute;
        width: 1px;
        ${isAfter ? 'right' : 'left'}: 0;
        display: block;
        top: 0;
        height: 100%;
        background: ${theme.palette.primary.main};
      `}
  `}
`;
const InnerContainer = styled('div', {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl }) => `
    display: flex;
    align-items: center;
    width: 100%;
    text-align: ${rtl ? 'right' : 'left'};
    > div {
      width: 100%;
    }
  `}
`;

export { CellDivider, Container, DragDummyPreview, DropHandler, InnerContainer, ResizeHandler };
//# sourceMappingURL=styled.js.map
